<template>
    <div class="page">
        <!--<van-tabs v-model="newsKind" @change="changeNewsKind">-->
            <!--<van-tab v-for="kind in newsKindList" :key="kind.id" :title="kind.name">-->
                <!---->
            <!--</van-tab>-->
        <!--</van-tabs>-->
        <van-list
                v-model="loading"
                :finished="finished"
                finished-text="没有更多了"
                @load="onLoad"
        >
            <van-cell v-for="item in kindNewsList" :key="item" style="padding: 0;" @click="gotoNewsDetail(item.id)">
                <div class="one-pic-news" v-if="item.imgList.length<3">
                    <van-row >
                        <van-col span="24">
                            <van-row>
                                <div class="big-news-title" style="margin-bottom: 10px;">{{item.title}}</div>
                            </van-row>
                        </van-col>
                    </van-row>
                    <van-row v-if="item.imgList.length>0">
                        <van-col span="24">
                            <img :src="item.imgList[0]" class="bignews-img">
                        </van-col>
                    </van-row>
                    <van-row >
                        <van-col span="24">
                            <van-row>
                                <div class="news-read" style="margin-bottom: 10px;">{{item.browseNum}}阅读</div>
                            </van-row>
                        </van-col>
                    </van-row>
                </div>
                <div class="more-pic-news" v-if="item.imgList.length>2" >
                    <van-row >
                        <div class="news-title-two">{{item.title}}</div>
                    </van-row>
                    <van-row>
                        <van-col span="8" >
                            <img :src="item.imgList[0]" class="news-img">
                        </van-col>
                        <van-col span="8" >
                            <img :src="item.imgList[1]" style="max-width:100%;" class="news-img">
                        </van-col>
                        <van-col span="8" >
                            <img :src="item.imgList[2]" class="news-img">
                        </van-col>
                    </van-row>
                    <van-row >
                        <div class="news-read">{{item.browseNum}}阅读</div>
                    </van-row>
                </div>
            </van-cell>
        </van-list>
    </div>
</template>

<script>
    import {healthKind} from '@/api/api'
    import {healthList} from '@/api/api'
    export default {
        name: "health-center",
        data(){
            return{
                loading:false,
                finished:true,
                newsKind:'country',
                kindNewsList:[],
                newsKindList:[]
            }

        },
        created(){
            this.getNewsKind()
        },
        methods:{
            onLoad(){

            },
            gotoNewsDetail(id){
                this.$router.push({path: '/healthdetail?healthId=' + id});
            },
            getNewsKind(){
                healthKind().then(res=>{
                    if (res.code==0){
                        this.newsKindList = res.data
                        this.getKindNews(0)
                    }
                })
            },
            changeNewsKind(index){
                this.getKindNews(index)
            },
            getKindNews(index){
                let params={

                }
                healthList(params).then(res=>{
                    if (res.code==0){
                        let list = []
                        for (let i=0;i < res.data.list.length;i++){
                            var info = res.data.list[i]
                            let imgList = []
                            if (info.pictureUrl && info.pictureUrl.length>0){
                                if (info.pictureUrl.indexOf(',') !== -1){
                                    imgList = info.pictureUrl.split(",");
                                }else{
                                    imgList.push(info.pictureUrl)
                                }
                            }
                            info.imgList = imgList
                            list.push(info)
                        }
                        this.kindNewsList = list;
                    }
                })
            },
        },
    }
</script>

<style scoped>
    .page{
        margin-right: 16px;
        margin-left: 16px;
    }
    .banner-area{
        margin-top: 18px;
        margin-bottom: 12px;
    }
    .banner-image{
        width: 100%;
        height: 160px;
        border-radius: 20px;
    }
    .font-12{
        font-size:12px;
    }
    .color-black{
        color:#282B31;
    }
    .color-gray{
        color:#999EA8;
    }
    .font-weight{
        font-family:PingFangTC-Regular,PingFangTC;
        font-weight:400;
        line-height: 41px;
    }
    .notice-area{
        margin-bottom: 12px;
        height:41px;
        background:rgba(103,178,255,0.2);
        box-shadow:0px 2px 8px 0px rgba(255,193,7,0.2);
        border-radius:12px;
    }
    .news-top{
        width: 100%;
        margin-top: 40px;
        height: 24px;
    }
    .news_left{
        width:3px;
        height:14px;
        margin-top: 5px;
        background:rgba(49,112,255,1);
        margin-right: 5px;
    }
    .news_text{
        font-size:17px;
        font-family:PingFangTC-Semibold,PingFangTC;
        font-weight:600;
        color:rgba(40,43,49,1);
        line-height:24px;
    }
    .one-pic-news{
        width: 100%;
        height: auto;
        padding-top: 24px;
        padding-bottom: 24px;

    }
    .big-news-title{
        height: auto;
        font-size:17px;
        font-family:PingFangSC-Regular,PingFang SC;
        font-weight:400;
        color:rgba(40,43,49,1);
        line-height:24px;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 3;
        -webkit-box-orient: vertical;
    }
    .news-title{
        height: 72px;
        font-size:17px;
        font-family:PingFangSC-Regular,PingFang SC;
        font-weight:400;
        color:rgba(40,43,49,1);
        line-height:24px;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 3;
        -webkit-box-orient: vertical;
    }
    .news-title-two{
        height: 48px;
        font-size:17px;
        font-family:PingFangSC-Regular,PingFang SC;
        font-weight:400;
        color:rgba(40,43,49,1);
        line-height:24px;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        margin-bottom: 12px;
    }
    .news-read{
        font-size:12px;
        font-family:PingFangTC-Regular,PingFangTC;
        font-weight:400;
        color:rgba(153,158,168,1);
        line-height:17px;
        margin-top: 12px;
    }
    .news-img{
        width: 110px;
        height: 89px;
        border-radius: 10px;
    }
    .bignews-img{
        width: 100%;
        height: 198px;
        border-radius: 10px;
    }
    .more-pic-news{
        width: 100%;
        height: 178px;
        padding-top: 24px;
        padding-bottom: 24px;
    }
    .gem-img{
        width: 100%;
        height: 258px;
        position: absolute;
        top: 0;
        left: 0;
    }
    .gem-area{
        width: 100%;
        height: auto;
        background: #fff;
        border-top-left-radius:20px;
        border-top-right-radius:20px;
        top:238px;
        left: 0;
        position: absolute;
        z-index: 100;
    }
    .user-info{
        height: 70px;
        padding-top: 25px;
        padding-bottom: 30px;
        background: #fff;
    }
    .user-head{
        width: 70px;
        height: 70px;
        margin-right: 12px;
        border-radius: 50%;
    }
    .user-name{
        font-size:20px;
        font-family:PingFangSC-Semibold,PingFang SC;
        font-weight:600;
        color:rgba(40,43,49,1);
        line-height:28px;
        margin-bottom: 12px;
    }
    .user-note{
        font-size:12px;
        font-family:PingFangTC-Regular,PingFangTC;
        font-weight:400;
        color:rgba(153,158,168,1);
        line-height:17px;
    }
    .user-jifen{
        width:167px;
        height:89px;
        background:rgba(255,129,80,1);
        box-shadow:0px 2px 8px 0px rgba(255,129,80,0.2);
        border-radius:12px;
    }
    .gem-item{
        width: 100%;
        height: 74px;
        background: #00000000;
    }
    .gem-item-img{
        width: 52px;
        height: 52px;
        border-radius: 5px;
        margin-right: 12px;
    }
    .gem-item-name{
        font-size:17px;
        font-family:PingFangTC-Regular,PingFangTC;
        font-weight:400;
        color:rgba(40,43,49,1);
        line-height:24px;
        margin-bottom: 4px;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
    }
    .gem-item-price{
        font-size:15px;
        font-family:PingFangSC-Regular,PingFang SC;
        font-weight:400;
        color:rgba(103,108,117,1);
        line-height:21px;
    }
    .gem-item-action{
        width:72px;
        height:33px;
        background:rgba(255,129,80,1);
        box-shadow:0px 42px 8px 0px rgba(255,129,80,0.2);
        border-radius:25px;
        margin-top: 9.5px;
        text-align: center;
        font-size:12px;
        font-family:PingFangTC-Semibold,PingFangTC;
        font-weight:600;
        color:rgba(255,255,255,1);
        line-height:33px;
    }
    .zhezhao{
        width: 100%;
        height: 100%;
        position: absolute;
        top:0;
        left:0;
    }
    .zhezhao-content{
        width: 100%;
        height: 100%;
        position: absolute;
        top:0;
        left:0;
    }
    .zhezhao-item-one{
        height: 89px;
        background:rgba(255,129,80,1);
        box-shadow:0px 2px 8px 0px rgba(255,129,80,0.2);
        border-radius:12px;
        position: relative;

    }
    .zhezhao-item-two{
        height: 89px;
        background:rgba(255,193,7,1);
        box-shadow:0px 2px 8px 0px rgba(255,129,80,0.2);
        border-radius:12px;
        position: relative;

    }
    .zhazhao-name{
        margin-top: 20px;
        margin-left: 16px;
        margin-bottom: 8px;
        font-size:17px;
        font-family:PingFangSC-Semibold,PingFang SC;
        font-weight:600;
        color:rgba(255,255,255,1);
        line-height:24px;
    }
    .zhazhao-value{
        font-size:12px;
        font-family:PingFangSC-Regular,PingFang SC;
        font-weight:400;
        color:rgba(255,255,255,1);
        line-height:17px;
        margin-left: 16px;
    }
    .jifen-info{
        margin-bottom: 20px;
    }
    .mine-action-name{
        font-size:17px;
        font-family:PingFangSC-Regular,PingFang SC;
        font-weight:400;
        color:rgba(40,43,49,1);
        line-height:24px;
    }
    .mine-action-item{
        width: 100%;
        height: 64px;
    }
    .fuc-name{
        font-size:12px;
        font-family:PingFangTC-Regular,PingFangTC;
        font-weight:400;
        color:rgba(103,108,117,1);
        line-height:17px;
        text-align: center;
    }
    .minepage{
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
        background:rgba(245,245,245,1);
    }
    .line{
        width: 100%;
        height: 1px;
        background:rgba(245,245,245,1);
    }
    .share-area{
        width:325px;
        height:307px;
        background:rgba(255,255,255,1);
        border-radius:16px;
    }
    .share-top{
        width:325px;
        height:93px;
        background:rgba(255,193,7,1);
        padding-top: 32px;
    }
    .top-one{
        font-size:20px;
        font-family:PingFangSC-Semibold,PingFang SC;
        font-weight:600;
        color:rgba(255,255,255,1);
        line-height:28px;
        margin-bottom: 12px;
        text-align: center;
    }
    .top-two{
        font-size:15px;
        font-family:PingFangSC-Regular,PingFang SC;
        font-weight:400;
        color:rgba(255,255,255,1);
        line-height:21px;
        text-align: center;
    }
    .share-bootom{
        margin-top: 32px;
    }
    .bottom-one {
        font-size:15px;
        font-family:PingFangSC-Regular,PingFang SC;
        font-weight:400;
        color:rgba(103,108,117,1);
        line-height:21px;
        text-align: center;
    }
    .bottom-two{
        font-size:15px;
        font-family:PingFangSC-Regular,PingFang SC;
        font-weight:400;
        color:rgba(103,108,117,1);
        line-height:21px;
        text-align: center;
    }
    .share-action{
        width:201px;
        height:48px;
        background:rgba(255,193,7,1);
        box-shadow:0px 2px 8px 0px rgba(255,193,7,0.2);
        border-radius:25px;
        margin: 0 auto;
        margin-top: 32px;
        font-size:17px;
        font-family:PingFangTC-Semibold,PingFangTC;
        font-weight:600;
        color:rgba(255,255,255,1);
        line-height:48px;
        text-align: center;
    }
    .sign-area{
        width:325px;
        height:463px;
        background:rgba(255,255,255,1);
        border-radius:16px;
    }
    .sign-top{
        width:325px;
        height:186px;
    }
    .share-bootom-one{

    }
    .bottom-item{
        width:56px;
        height:67px;
        background:rgba(242,241,240,1);
        border-radius:8px;
        padding-top: 6px;
        margin-bottom: 5px;
    }
    .bottom-item-one{
        font-size:17px;
        font-family:PingFangSC-Regular,PingFang SC;
        font-weight:400;
        color:rgba(255,120,64,1);
        line-height:24px;
        text-align: center;
        margin-bottom: 4px;
    }
    .bottom-item-two{
        width: 32px;
        height: 32px;
        margin: 0 auto;
        display: block;
    }
</style>